import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {renderIf} from 'views/Shared'
import {GoDotFill} from 'react-icons/go'

export const DatePlaceItem = ({showIcon = false, className = 'text-sm', label, date, place}) => {
    const t = useTranslate()
    return (
        <div className={classNames("space-x-1 text-color-400 ", className)}>
            {renderIf(
                showIcon === true,
                <GoDotFill size={className ? 10 : 12} className="text-color-500"/>
            )}
            <span className="italic whitespace-no-wrap">{`${label ? t(label) : t('date')} : `}</span>
            <span className="font-semibold text-color-100">{date}</span>
            {renderIf(
                place,
                <span className="whitespace-no-wrap">{t('in')}</span>
            )}
            {renderIf(
                place,
                <span className="font-semibold text-color-100">{place}</span>
            )}
        </div>
    )
}
